import { useQuery } from '@tanstack/react-query'

import { getContractPreview } from '@flecto/api/shared'
import { type ParameterID } from '@flecto/types'

type GetContractPreviewOptions = {
  bookingId: ParameterID
  enabled?: boolean
}

export const useQueryGetContractPreview = ({
  bookingId,
  enabled = true,
}: GetContractPreviewOptions) => {
  return useQuery({
    queryKey: ['QueryGetContractPreview', Number(bookingId)],
    queryFn: async () => await getContractPreview(bookingId ?? ''),
    retry: 1,
    refetchOnMount: true,
    enabled,
  })
}
